import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IBankAccountResponse } from '../../models/bank-account.model';
import {
  IBillingPortalRequest,
  IBillingPortalResponse,
} from '../../models/billing-portals.model';
import { IPromotionCode } from '../../../features/signup/models/coupons.model';

export interface ILedgerService {
  getBillingPortal(
    request: IBillingPortalRequest,
  ): Observable<IBillingPortalResponse>;
  getPromotionCode(code: string): Observable<IPromotionCode>;
  getBankAccount(): Observable<IBankAccountResponse>;
  saveBankAccount(publicToken: string): Observable<void>;
  removeBankAccount(): Observable<void>;
}

@Injectable({
  providedIn: 'root',
})
export class LedgerService implements ILedgerService {
  constructor(private http: HttpClient) {}

  getBillingPortal({ return_url }): Observable<IBillingPortalResponse> {
    const url = `${environment.ledgerUri}/api/billing_portals`;
    return this.http.post<IBillingPortalResponse>(url, {
      return_url,
    });
  }

  getPromotionCode(code: string): Observable<IPromotionCode> {
    const url = `${environment.ledgerUri}/api/coupons/${code}`;
    return this.http.get<IPromotionCode>(url);
  }

  getBankAccount(): Observable<IBankAccountResponse> {
    const url = `${environment.ledgerUri}/api/customer/bank_account`;
    return this.http.get<IBankAccountResponse>(url);
  }

  saveBankAccount(publicToken): Observable<void> {
    const url = `${environment.ledgerUri}/api/customer/bank_account`;
    return this.http.put<void>(url, { public_token: publicToken });
  }

  removeBankAccount(): Observable<void> {
    const url = `${environment.ledgerUri}/api/customer/bank_account`;
    return this.http.delete<void>(url);
  }
}
